import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
//import Slide from '@mui/material/Slide';

export default function ToastMessage({
  show,
  remove,
  opPerform,
  global,
  customText,
  duration
}) {

  const handleClose = () => {
    remove(null);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={20} ref={ref} variant="filled" {...props} />;
  });

  return (
    <Box sx={{ width: 300 }}>
      <Grid container justifyContent="center"></Grid>
      <Snackbar
        // anchorOrigin= {'vertical'}
        autoHideDuration={duration?duration:4000}
        transitionDuration={3000}
        open={show}
        onClose={handleClose}
        //key={transition ? transition.name : ""}
      >
        {customText ? (
          <Alert
            onClose={handleClose}
            severity={opPerform ? "success" : "error"}
            sx={{ width: "150%", padding: "1rem 3rem" ,whiteSpace: "pre-line"}}
          >
            {customText}
          </Alert>
        ) : (
          <Alert
            onClose={handleClose}
            severity={opPerform ? "success" : "error"}
            sx={{ width: "150%", padding: "1rem 3rem" }}
          >
            {opPerform ? "با موفقیت انجام شد" : "خطای سرور..!"}
          </Alert>
        )}
      </Snackbar>
    </Box>
  );
}
/**========================================================================
 *                             1402/10/24      user:javad
 * 
 *        TODO: add Props:customText
 *        Description: برای زمانی که می خواهیم پیام های مختلف را پاس دهیم
 *        exampele:<ToastMessage
          {...}
          customText={toast?.toastText}
        />  
        2=
        const handleFailed = (text :pass text when call function) => {
          setToast((prev) => ({ ...prev, asyncOperation: false, showToast: true ,toastText:text }));
        };  
 *  
 *========================================================================**/